function initCardImage(img) {
  if (img.complete && img.naturalWidth > 0) {
    img.classList.add('is-loaded');
    return;
  }
  img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
  img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
}

function initAllCardImages() {
  document.querySelectorAll('.card-product img').forEach(initCardImage);
}

// Run on initial load
document.addEventListener('DOMContentLoaded', initAllCardImages);

// Watch for dynamically injected cards (related products, recommendations, etc.)
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      // Check if the node itself is a card image
      if (node.matches?.('.card-product img')) {
        initCardImage(node);
      }
      // Check for card images within the added node
      node.querySelectorAll?.('.card-product img').forEach(initCardImage);
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });
